$(document).ready(function(){

  // collection page 301 redirection
  if (window.location.href === 'https://www.reranger.com/collections/all') {
      // Redirect to the target URL
      window.location.href = 'https://www.reranger.com/collections/shop-all';
  }
  
  $('.riactslider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 100,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true
  });  
  // Duster featured slider-showcase*************
  $('.featured-slide-duster').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    infinite: false,
    autoplaySpeed: 4000
  });
  // Duster shop cards******************
  $('.duster-cards-wrapper').slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  arrows: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,arrows: true
      }
    }
  ]
  });
  // clearsight nav wrapper slider*******************
   $('.lens-discovery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
     adaptiveHeight: true,
    asNavFor: '.clearsight-thumbnail-nav'
  });
  $('.clearsight-thumbnail-nav').slick({
    slidesToShow: 5,
    infinite: true,
    slidesToScroll: 1,
    asNavFor: '.lens-discovery',
    dots: false,
    arrows: true,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
  });
  // Pro staff lenses slider*****************************
  $('.staff-slider-lenses').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true
    });  
  // Hide product details if info is empty
  var tableContent = $.trim($('.about-pdp .product-detail table tbody').text());
  if(tableContent.length == 0){
    $('.about-pdp').hide();
  }

  // Profile Opener**************************
  $('.staff-member').click(function(){
    $(this).find('.staff-modal').show();
    $('header').hide();
    $('body').addClass('active-profile-modal');
  });
  $(document).on("click", '.modal-dropper', function(event) { 
    $(this).parent().hide();
    $('header').show();
    $('body').removeClass('active-profile-modal');
  });

  // Footer*****************************
  if ($(window).width() < 900) {
   $('.footer__block-list p.bold').click(function(){
    $(this).parent().toggleClass('menu-open');
    $(this).parent().siblings().removeClass('menu-open');
    $(this).parent().find('ul.v-stack').slideToggle();
    $(this).parent().siblings().find('ul.v-stack').slideUp();
  });
  }

  // Warning text
  $('.warning-trigger').click(function(){
    $(this).find('.ad-open').toggle();
    $(this).find('.ad-close').toggle();
    $(this).next().slideToggle();
  });

  // contact us hide success message after 5 seconds
  setTimeout(function() { $(".contact-form .banner--success").hide(); }, 5000);

  // Size selection required before add to cart (RandolphUSA behavior)
  function getVariantPicker(formId) {
    return document.querySelector('variant-picker[form="' + formId + '"]');
  }

  function requiresSizeSelection(formId) {
    var picker = getVariantPicker(formId);
    return picker && picker.querySelector('[data-require-size-selection]') !== null;
  }

  function isSizeSelected(formId) {
    var picker = getVariantPicker(formId);
    if (!picker) return true;
    var sizeField = picker.querySelector('[data-require-size-selection]');
    if (!sizeField) return true;
    if (sizeField.querySelector('input[type="radio"][name^="option"]:checked')) return true;
    var hiddenInput = sizeField.querySelector('input[type="hidden"][name^="option"]');
    return hiddenInput && hiddenInput.value !== '';
  }

  function showSizeError(formId, shouldScroll) {
    var picker = getVariantPicker(formId);
    if (!picker) return;
    var sizeError = picker.querySelector('.product-form__size-error');
    if (sizeError) sizeError.style.display = '';
    if (shouldScroll === false) return;
    var sizeField = picker.querySelector('[data-require-size-selection]');
    if (sizeField) sizeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideSizeError(formId) {
    var picker = getVariantPicker(formId);
    if (!picker) return;
    var sizeError = picker.querySelector('.product-form__size-error');
    if (sizeError) sizeError.style.display = 'none';
  }

  function enforceSizeSelectionState(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    if (requiresSizeSelection(form.id) && !isSizeSelected(form.id)) {
      idInput.disabled = true;
      idInput.value = '';
    }
  }

  function blockAddToCartWithoutSize(event, formId) {
    if (!requiresSizeSelection(formId) || isSizeSelected(formId)) return false;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showSizeError(formId, true);
    return true;
  }

  function getProductFormId() {
    var form = document.querySelector('form[is="product-form"]');
    return form ? form.id : null;
  }

  function isRxLensButton(target) {
    return !!target.closest('lensadvizor-quick-buy, button.la-prescription-form-btn, .la-prescription-form-btn');
  }

  function initSizeSelectionForForms(root) {
    (root || document).querySelectorAll('form[is="product-form"]').forEach(function(form) {
      enforceSizeSelectionState(form);
    });
  }

  initSizeSelectionForForms();

  document.addEventListener('submit', function(event) {
    var form = event.target.closest ? event.target.closest('form[is="product-form"]') : null;
    if (!form) return;
    blockAddToCartWithoutSize(event, form.id);
  }, true);

  /**
   * Normalize a string the same way as the theme alt-based gallery filter.
   */
  function normalizeMediaKey(value) {
    return String(value || '').toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
  }

  function isGalleryMediaVisible(el) {
    if (!el || el.hidden) return false;
    return getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';
  }

  /**
   * Find the gallery media element that belongs to the selected variant.
   */
  function findVariantGalleryMedia(variant, product) {
    var gallery = document.querySelector('.product .product-gallery') || document.querySelector('product-gallery');
    if (!gallery || !variant) return null;

    var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__media'));
    if (!mediaItems.length) return null;

    // 1) Prefer Shopify featured_media attached to the variant
    if (variant.featured_media && variant.featured_media.id) {
      var featured = gallery.querySelector('.product-gallery__media[data-media-id="' + variant.featured_media.id + '"]');
      if (featured) {
        // Ensure the featured image is visible before scrolling to it
        featured.hidden = false;
        featured.style.display = '';
        return featured;
      }
    }

    // 2) Fall back to alt-text matching (same rules as theme.js)
    var productTitle = normalizeMediaKey(product && product.title);
    var isTempleStyle = ['falcon', 'edge-frame'].some(function(item) {
      return productTitle.indexOf(item) !== -1;
    });

    var matchKey;
    if (isTempleStyle) {
      var selectedOpt = String(variant.option2 || variant.option1 || '').toLowerCase();
      matchKey = selectedOpt.split('-')[0].trim();
    } else {
      matchKey = normalizeMediaKey(variant.title);
    }

    if (!matchKey) return null;

    var matched = mediaItems.filter(function(el) {
      if (!isGalleryMediaVisible(el)) return false;
      var img = el.querySelector('img');
      if (!img || !img.alt) return false;
      var altKey = normalizeMediaKey(img.alt);
      return isTempleStyle ? altKey.indexOf(matchKey) !== -1 : altKey === matchKey;
    });

    return matched[0] || null;
  }

  function isMobileGallery() {
    return window.matchMedia('(max-width: 999px)').matches;
  }

  /**
   * Desktop: scroll the page to the variant image.
   * Mobile: only scroll the slider to that image (no page scroll).
   */
  function scrollGalleryToVariantImage(event) {
    if (!event.detail || !event.detail.variant) return;

    // Wait so alt show/hide in theme.js can update layout first
    requestAnimationFrame(function() {
      setTimeout(function() {
        var target = findVariantGalleryMedia(event.detail.variant, event.detail.product);
        if (!target) return;

        var carousel = target.closest('media-carousel');

        if (isMobileGallery() && carousel) {
          var slideIndex = -1;
          if (carousel.items && typeof carousel.items.indexOf === 'function') {
            slideIndex = carousel.items.indexOf(target);
          } else {
            slideIndex = Array.prototype.indexOf.call(carousel.children, target);
          }

          if (slideIndex >= 0 && typeof carousel.select === 'function') {
            carousel.select(slideIndex, { animate: true, force: true });
          } else {
            carousel.scrollTo({
              left: target.offsetLeft,
              behavior: 'smooth'
            });
          }
          return;
        }

        // Desktop grid: scroll the page to the matching image
        var stickyOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height'), 10) || 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset - 20;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      }, 50);
    });
  }

  document.addEventListener('variant:change', function(event) {
    var form = event.target && event.target.closest
      ? event.target.closest('form[is="product-form"]')
      : null;
    if (!form && !(event.target && event.target.matches && event.target.matches('form[is="product-form"]'))) {
      return;
    }
    var formEl = form || event.target;
    if (!isSizeSelected(formEl.id)) {
      enforceSizeSelectionState(formEl);
    }
    scrollGalleryToVariantImage(event);
  });

  document.documentElement.addEventListener('quick-buy:loaded', function(event) {
    if (!event.detail || !event.detail.drawer) return;
    initSizeSelectionForForms(event.detail.drawer);
    setTimeout(function() {
      initSizeSelectionForForms(event.detail.drawer);
    }, 1000);
  });

  document.addEventListener('click', function(event) {
    if (isRxLensButton(event.target)) {
      var formId = getProductFormId();
      if (formId && requiresSizeSelection(formId) && !isSizeSelected(formId)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        showSizeError(formId, false);
        document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'));
      }
      return;
    }

    var submitButton = event.target.closest('buy-buttons button[type="submit"]');
    if (!submitButton) return;
    var buyButtons = submitButton.closest('buy-buttons');
    if (!buyButtons) return;
    blockAddToCartWithoutSize(event, buyButtons.getAttribute('form'));
  }, true);

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-require-size-selection] input[type="radio"][name^="option"]')) return;
    if (!event.target.checked) return;
    var picker = event.target.closest('variant-picker');
    if (!picker) return;
    var formId = picker.getAttribute('form');
    hideSizeError(formId);
    var form = document.getElementById(formId);
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;
    }
  });

  // Variant picker loads async; re-enforce after init
  setTimeout(function() {
    initSizeSelectionForForms();
  }, 1000);

});